import $config from "@/helpers/config/index";
import amplitude from "amplitude-js";

amplitude.getInstance('hilfy').init($config.amplitude);
window.amplitude = amplitude;

if (window.location.search && window.location.search.includes('utm_source')) {
    if (localStorage) {
        const identify = new amplitude.Identify().set('utm', localStorage.getItem('utmUrl'));
        amplitude.getInstance('hilfy').identify(identify);
    }
}